import React from 'react'
import { NavLink } from 'react-router-dom'

const SidebarTab = ({ label = 'SidebarTab', path = '/' }) => {
  return (
    <NavLink to={path} className={'sidebar bg-blue-100 rounded hover:text-white hover:bg-blue-500 text-blue-500 '}>
      <div className='py-2 px-3'>
        <p className='font-semibold capitalize'>{label}</p>
      </div>
    </NavLink>
  )
}

export default SidebarTab